import helper from '../../preorder/api/helper';
import config from '../../preorder/configs/config';

const API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-wishListCommand`;

const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
};

export const getRecentPurchasedItems = (token, amount) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getRecentPurchasedItems',
    amount,
    token,
  },
});

export const getSubscribedItems = (token) => helper.get({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
    command: 'getSubscribedItems',
    token,
  },
});

export const subscribeItems = (token, ids) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    command: 'subscribe',
    ids,
    token,
  },
});

export const unsubscribeItems = (token, ids) => helper.post({
  url: API_ENDPOINT,
  query: {
    ...DEFAULT_QUERY,
  },
  body: {
    command: 'unsubscribe',
    ids,
    token,
  },
});
